export default __webpack_public_path__ + "static/media/hiflix-logo.06921f5c.svg";